import { FileViewIcon } from "@hugeicons-pro/core-solid-rounded";
import { IconAI } from "shared/components/ai/IconAI";

/** The underwriting agent (BSCPF-6141): the agent circle with a document-with-an-eye glyph. */
export const IconAIUnderwritingAgent = ({
  bgSize = 44
}: {
  bgSize?: number;
}) => <IconAI bgSize={bgSize} icon={{ Icon: FileViewIcon }} />;
